import { CopyOutlined, DownloadOutlined } from '@ant-design/icons';
import { Avatar, Button, Card, Descriptions, Modal, Space, Typography } from 'antd';
import React from 'react';
import { showSuccessMessage } from '../../utils';
import QuotationInfoAlert from '../vendor/vendor-quotations/QuotationInfoAlert';
import {
  downloadContactDetails,
  renderContactNumber,
  VENDOR_CONTACT_THEME,
  VENDOR_DETAIL_FIELDS,
} from './businessDetailsTheme';

export default function BusinessDetailsModal({
  isVisible,
  onClose,
  item,
  avatarStyle,
}) {
  const vendor = item?.vendorDocs?.[0];
  const infoMessage = item?.vendorDetailsInfoMessage || '';
  const colors = VENDOR_CONTACT_THEME.enterprise;

  if (!isVisible || !vendor) return null;

  const handleDownload = () => {
    downloadContactDetails(vendor, 'seller');
  };

  const handleCopyGstin = async (event) => {
    event.stopPropagation();
    if (!vendor.legal_gstin_number) return;
    try {
      await navigator.clipboard.writeText(vendor.legal_gstin_number);
      showSuccessMessage('GSTIN copied');
    } catch {
      showSuccessMessage('Unable to copy GSTIN');
    }
  };

  const renderFieldValue = (key, value) => {
    if (key === 'business_poc_mobile') {
      return renderContactNumber(value);
    }
    return value || '—';
  };

  return (
    <Modal
      open={isVisible}
      title="Seller Info"
      onCancel={onClose}
      footer={null}
      className="Quotes_modal Modal_ht Modal_vendorDetails"
      destroyOnClose
      width={520}
      zIndex={1200}
    >
      {infoMessage ? (
        <QuotationInfoAlert
          message={infoMessage}
          className="Quotation_modalAlert--inDialog VendorDetails_lockedAlert"
        />
      ) : null}
      <Card bordered={false} className="VendorDetails_card">
        <Space align="center" size={12} className="VendorDetails_header">
          <Avatar size={48} style={avatarStyle}>
            {vendor.name?.charAt(0)?.toUpperCase() || '?'}
          </Avatar>
          <div className="VendorDetails_headerText">
            <Typography.Title level={5} className="VendorDetails_name">
              {vendor.name || '—'}
            </Typography.Title>
            {vendor.legal_gstin_number ? (
              <div className="VendorDetails_gstinRow">
                <Typography.Text type="secondary" className="VendorDetails_gstin">
                  {vendor.legal_gstin_number}
                </Typography.Text>
                <button
                  type="button"
                  className="VendorDetails_copyBtn"
                  aria-label="Copy GSTIN"
                  onClick={handleCopyGstin}
                >
                  <CopyOutlined />
                </button>
              </div>
            ) : null}
          </div>
        </Space>

        <Descriptions
          column={1}
          size="middle"
          colon={false}
          className="VendorDetails_descriptions VendorDetails_descriptions--enterprise"
        >
          {VENDOR_DETAIL_FIELDS.map(({ key, label }) => (
            <Descriptions.Item key={key} label={label}>
              {renderFieldValue(key, vendor[key])}
            </Descriptions.Item>
          ))}
        </Descriptions>

        <div className="VendorDetails_actions">
          <Button
            type="primary"
            size="middle"
            icon={<DownloadOutlined />}
            onClick={handleDownload}
            className="VendorDetails_downloadBtn VendorDetails_downloadBtn--enterprise"
            style={{
              background: colors.primary,
              borderColor: colors.primary,
            }}
          >
            Download
          </Button>
        </div>
      </Card>
    </Modal>
  );
}
